import { createMuiTheme } from "@material-ui/core/styles";
import { ServerStyleSheets } from "@material-ui/styles";

// Create a theme instance.
export const theme = createMuiTheme({
  typography: {
    fontFamily: "inherit",
  },
  palette: {
    primary: {
      main: "#2E508F",
    },
    secondary: {
      main: "#171923",
    },
  },
});

export const removeServersideStylesInBrowser = () => {
  const jssStyles = document.querySelector("#jss-server-side");
  if (jssStyles) {
    jssStyles.parentNode.removeChild(jssStyles);
  }
};

export function createMaterialUiStyleSheet() {
  return new ServerStyleSheets();
}
